import { BlockDefinition } from '../../types'
import ImageBlock from './ImageBlock'

// Legacy equivalent: image (logos and header graphics included)
const imageBlock: BlockDefinition<'image'> = {
  type: 'image',
  createDefaultProps: () => ({
    source: null,
    width: null,
    height: null,
    alt: '',
    caption: '',
    link: ''
  }),
  Component: ImageBlock,
  supportsFullWidth: true
}

export default imageBlock
